import {getDevice} from "../../bcom-device/bcom-device.min";

function prihlaseni($formular = $('#formular-prihlaseni')) {
    var $form = $formular;
    var $inputFingerprint = $('#zarizeni-fingerprint');
    var $inputOS = $('#zarizeni-os');
    var $inputProhlizec = $('#zarizeni-prohlizec');

    if ($form.length) {
        $form.submit(async function (e) {
            e.preventDefault();

            // Detekce prohlizece
            let device = getDevice();

            $inputFingerprint.val(device.id);
            $inputOS.val(device.os.name + " " + device.os.version);
            $inputProhlizec.val(device.browser.name + " " + device.browser.version);

            $form.off('submit').submit();
        });
    }
}

function prihlaseniEmailOtp() {
    $.ajax({
        type: 'post',
        url: '/prihlaseni/otp/email',
        dataType: "json",
        beforeSend: function () {
            Lemo_Alert.addInfo('Odesílám e-mail...', 'prihlaseniEmailOtp');
        },
        complete: function () {
            Lemo_Alert.closeById('prihlaseniEmailOtp');
        },
        success: function (response) {
            if (!response.c) {
                Lemo_Alert.addSuccess('E-mail byl úspěšně odeslán na e-mailovou adresu vyplněnou ve Vašem uživatelském účtu.', 'generovaniCSV');
            } else {
                Lemo_Alert.addDanger(response.c);
            }
        }
    });
}

$(document).ready(function () {
    prihlaseni();

    $('#prihlaseni-otp-email').on('click', function (e) {
        e.preventDefault();

        prihlaseniEmailOtp();

        return false;
    });
});
